import { SupportTicketPayload } from "@/domain/SupportTicketPayload";
import { ApiService } from "./ApiService";
import type {
  SupportTicketDto,
  SupportTicketMessage,
} from "@shared/types/SupportTicketDto";

export interface AddMessageInput {
  ticketId: string;
  message: Omit<SupportTicketMessage, "id">;
}

export interface ResolveTicketInput {
  ticketId: string;
  reason: string;
}

class SupportTicketService {
  constructor(private readonly apiService: ApiService) {}

  async getTickets(): Promise<SupportTicketDto[]> {
    return this.apiService.request<SupportTicketDto[]>(
      "/support-tickets/list",
      {
        method: "GET",
        requireAuth: true,
      },
    );
  }

  async getTicket(ticketId: string): Promise<SupportTicketDto> {
    return this.apiService.request<SupportTicketDto>(
      `/support-tickets/${ticketId}`,
      {
        method: "GET",
        requireAuth: true,
      },
    );
  }

  async createTicket(data: SupportTicketPayload): Promise<SupportTicketDto> {
    return this.apiService.request<SupportTicketDto>(
      "/support-tickets/create",
      {
        method: "POST",
        body: JSON.stringify(data),
        requireAuth: true,
      },
    );
  }

  async addMessage(
    data: AddMessageInput,
  ): Promise<{ success: boolean; message: SupportTicketMessage }> {
    return this.apiService.request<{
      success: boolean;
      message: SupportTicketMessage;
    }>(`/support-tickets/add-message/${data.ticketId}`, {
      method: "PATCH",
      body: JSON.stringify(data.message),
      requireAuth: true,
    });
  }

  async resolveTicket(data: ResolveTicketInput): Promise<{ success: boolean }> {
    return this.apiService.request<{ success: boolean }>(
      `/support-tickets/resolve/${data.ticketId}`,
      {
        method: "PATCH",
        body: JSON.stringify({ reason: data.reason }),
        requireAuth: true,
      },
    );
  }
}

export default SupportTicketService;
